import React, { useEffect, useState } from "react";
import "./styles.scss";

import Thumbimg from "../../assets/images/courses/course_thumb01.jpg";

import { Link, useNavigate } from "react-router-dom";
import { RiFileTextLine, RiTimeLine } from "react-icons/ri";

import { useDispatch, useSelector } from "react-redux";
import { addToCart, fetchCartItems } from "../../store2/features/cartSlice";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useScroll } from "../../router/Scroll/ScrollContext";
import {
  callAlert,
  getUserDetails,
  secondsToHms,
} from "../../services/CommonService";

import { LiaPagerSolid } from "react-icons/lia";
import { setTrailDetails, subscriptionTrial } from "../../services/AuthService";

export default function CourseCard({ course }) {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.items);
  const { scrollToSection } = useScroll();
  let session = 0;
  if (course?.moduleList && course?.moduleList.length > 0) {
    course?.moduleList.forEach((d) => {
      if (d.contentList.length > 0) {
        d.contentList.forEach((d) => {
          session++;
        });
      }
    });
  }

  const [minimumPrice, setMinimumPrice] = useState(0);

  const navigate = useNavigate();

  // const notify = () => toast.success(`${course.courseName} added to cart`);
  const notify = (payload) => {
    const alreadyPurchased = payload?.map((item) => item);

    if (alreadyPurchased?.length > 0) {
      toast.warn(
        <>
          {alreadyPurchased?.map((item) => (
            <>
              <strong>{item} </strong>already purchased
              <br />
            </>
          ))}
          <strong>Rest modules are added into the cart</strong>
        </>,
      );
    } else {
      toast.success(
        <>
          {course?.courseName} <strong>added to cart</strong>
        </>,
      );
    }
  };

  const userDetailss = getUserDetails();

  const handleAddToCart = async () => {
    if (!userDetailss) {
      toast.error(
        <>
          Please <strong>login first</strong>
        </>,
        { theme: "colored" },
      );
    } else {
      const moduleList = course?.modules.map((module) => module.id);

      const result = await dispatch(
        addToCart({ courseId: course.id, moduleList }),
      );
      if (result.payload?.resultCode != 1) {
        callAlert("", result.payload?.message);

        return;
      }

      dispatch(fetchCartItems());
      scrollToSection("top");
      notify(result.payload?.data);
      const timeoutId = setTimeout(() => {
        navigate("/cart");
      }, 1000);
      return () => clearTimeout(timeoutId);

      // // const isCourseInCart = cartItems?.some(item => item.id === course.id);
      // if (isCourseInCart) {
      //   // If the course is already in the cart, display an error toast
      //   toast.error(
      //     <>
      //       {course?.courseName} <strong>is already in the cart</strong>
      //     </>, { theme: "colored" });
      // } else {
      // If the course is not in the cart, dispatch the addToCart action and display a success toast
    }
  };

  const handleAddToCartFree = async (id) => {
    navigate("/register", {
      state: {
        courseBoard: course?.board?.toLowerCase(), // "ICSE" → "icse"
        courseGrade: course?.grade?.toLowerCase(), // "Class 9" → "class 9"
      },
    });
    setTrailDetails({
      modeClass: id,
    });
    if (!userDetailss) {
      toast.error(
        <>
          Please <strong>Sign up first</strong>
        </>,
        { theme: "colored" },
      );

      // return;
    } else {
      subscriptionTrial((d) => {
        navigate(`/user/dashboard`, {});
      });
    }
  };

  const truncateText = (text, maxLength) => {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "..."; // Add ellipsis to indicate truncation
    } else {
      return text;
    }
  };

  const openCourse = () => {};

  useEffect(() => {
    const getMinimumModulePrice = (moduleList) => {
      if (!moduleList || moduleList.length === 0) return 0;

      return Math.min(...moduleList.map((module) => module.price));
    };

    // const minPrice = getMinimumModulePrice(moduleList);
    const minPrice = getMinimumModulePrice(course?.moduleList);

    setMinimumPrice(minPrice);

    console.log("minprice", minPrice);
  }, [course]);

  // updated by Malik - returns correct route based on board type
  const getCourseRoute = (course) => {
    const board = course?.board?.toUpperCase();
    if (board === "CBSE" || board === "ICSE") {
      // if (board === "CBSE" || board === "ICSE") {
      return `/course-details/${course.id}#course-details`;
    }
    return `/other-course-details/${course.id}`;
  };

  return (
    <div className="coursescard-item" onClick={openCourse}>
      <div className="courses-thumb"></div>
      <div>
        {" "}
        <div className="courses-content pb-0">
          <h5 className="title">
            {/* <Link to={`/course-details/${course.id}#course-details`}> */}
            <Link to={getCourseRoute(course)}>
              {truncateText(course.courseName, 40)}
            </Link>
          </h5>
        </div>
        <div className="image-container">
          {/* <Link to={`/course-details/${course.id}#course-details`}> */}
          <Link to={getCourseRoute(course)}>
            {course.image ?
              <img src={course.image} alt="img" />
            : <img src={Thumbimg} alt="img" />}
          </Link>
        </div>
      </div>
      <div className="courses-content">
        <ul className="courses__item-meta list-wrap">
          <li>
            <i>
              <RiFileTextLine />
            </i>
            <p>
              <strong>{course?.modules?.length}</strong> Modules
            </p>
          </li>
          <br />
          {session > 0 && (
            <li>
              <i>
                <LiaPagerSolid />
              </i>
              <p>
                <strong>{session}</strong> Sessions
              </p>
            </li>
          )}
          {/* {course.courseDuration > 0 && (
            <li>
              <i>
                <RiTimeLine />
              </i>
              {secondsToHms(course.courseDuration)}
            </li>
          )} */}
        </ul>

        <div className="courses__item-bottom">
          {/* <div className="d-flex align-items-center justify-content-between flex-direction-column"> */}
          <span
            style={{ marginLeft: "5px", fontStyle: "italic" }}
            className="jadoo"
          >
            {/* ~{minimumPrice > 0 ? `Starting at ₹${minimumPrice}` : "Free"} */}
            {course?.board !== "Other" ?
              minimumPrice > 0 ?
                <>
                  ~Starting at <strong>₹{minimumPrice}</strong>
                </>
                // <strong>Free</strong>
              : <></>
            : <>
                ~ Enroll at <s>₹{course.discount}</s> {" "} <strong>₹{course?.price}</strong>
              </>
            }
          </span>
          <div className="courses__item-actions justify-content-between">
            <h5 className="price">
              {/* <Link to={`/course-details/${course.id}#course-details`} className="btn btn-dark btn-primar4 mt-2 rounded-pill"> */}
              <Link
                to={getCourseRoute(course)}
                className="btn btn-dark btn-primar4 mt-2 rounded-pill"
              >
                Full course
              </Link>
              {/*    <del>₹{course.price}</del> */}
              {/* ₹{course.discount} */}
              {/* {userDetailss && userDetailss ? (
           <button
              className="btn btn-dark mt-1 rounded-pill" 
              onClick={handleAddToCart}
              
            >
              Buy now
            </button>
          ) : (
           <button
              className="btn btn-dark mt-1 rounded-pill" 
              onClick={handleAddToCart}
              data-bs-toggle="modal"
              data-bs-target="#loginModal"
            >
              Buy now
            </button>
          )} */}
            </h5>

            {
              course?.board !== "Other" &&
                (userDetailss ?
                  userDetailss["mode"] === "NA" && (
                    <button
                      className="btn btn-primary btn-primar3 rounded-pill"
                      onClick={() => handleAddToCartFree(course?.id)}
                    >
                      Free trial
                    </button>
                  )
                : <button
                    className="btn btn-primary btn-primar3 rounded-pill"
                    onClick={() => handleAddToCartFree(course?.id)}
                    data-bs-toggle="modal"
                    data-bs-target="#registerModal"
                  >
                    Free trial
                  </button>)

              // <button
              //   className="btn btn-primary btn-primar3  rounded-pill"
              //   onClick={() => handleAddToCartFree(course?.id)}
              //   data-bs-toggle="modal"
              //   data-bs-target="#registerModal"
              // >
              //   Free trial
              // </button>
            }
          </div>
        </div>
      </div>
    </div>
  );
}
